export default __webpack_public_path__ + "static/media/bun.f24f5bcb.svg";